import { app } from '../../../../../../app';
import { Controller } from './add-domain.controller';

app.component('companyDirectoryIntegrationManageDomainsAddDomain', {
    bindings: {
        companyId: '<',
        directory: '<',
        domains: '<',
    },
    controller: Controller,
    templateUrl: require('./add-domain.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/domains/add-domain/add-domain.component.js